import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ProductCard from '../../components/ProductCard';
import { serviceService, ServiceCard } from './serviceService';

const TITLES: Record<string, string> = {
  GameService: 'Игровые сервисы',
  Entertainment: 'Развлечения',
  AI: 'AI-сервисы',
  Work: 'Сервисы для работы',
  Other: 'Другие сервисы',
};

const ServiceCatalogPage = () => {
  const { category = '' } = useParams<{ category: string }>();
  const [services, setServices] = useState<ServiceCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    serviceService.list(category)
      .then(items => { if (!cancelled) setServices(items); })
      .catch(() => { if (!cancelled) setError('Не удалось загрузить товары'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [category]);

  return (
    <main className="min-h-screen bg-background px-4 py-6 text-foreground sm:py-8">
      <div className="mx-auto max-w-[90rem]">
        <Link to="/" className="text-sm text-foreground/50 transition-colors hover:text-foreground">← На главную</Link>
        <div className="mb-8 mt-3">
          <h1 className="text-4xl font-bold tracking-tight sm:text-6xl">{TITLES[category] ?? 'Онлайн-сервисы'}</h1>
          {!loading && !error && <p className="mt-3 text-foreground/45">Найдено товаров: {services.length}</p>}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            {Array.from({ length: 6 }, (_, index) => <div key={index} className="aspect-[4/5] animate-pulse rounded-[28px] bg-foreground/5" />)}
          </div>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : services.length === 0 ? (
          <p className="text-foreground/50">В этой категории пока нет товаров.</p>
        ) : (
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            {services.map(service => <ProductCard key={service.id} product={service} hrefBase="/service" />)}
          </div>
        )}
      </div>
    </main>
  );
};

export default ServiceCatalogPage;
